import { Drawer, Flexer, Heading, ModalClose, Text, View } from '@fold-dev/core'
import { useEffect, useState } from 'react'

export const MyTasksModal = ({ onDismiss }) => {
    const [page, setPage] = useState(0)
    const [loading, setLoading] = useState(false)

    const fetchData = async () => {
        /* setLoading(true)
        setError(false)

        try {
            const { data } = await GraphqlService.getInstance().notifications(userId, page)

            setLoading(false)
            setPage(page + 1)
            dispatch(hydrateNotifications(data.notifications))
        } catch (e) {
            logger(e)
            setLoading(false)
            setError(typeof e == 'string' ? e : 'An error occured')
        } */
    }

    // Get all the teams
    useEffect(() => {
        fetchData()
    }, [page])

    return (
        <Drawer
            width="50%"
            anchor="left"
            onDismiss={onDismiss}
            isVisible={true}
            header={
                <>
                    <Heading>My Tasks</Heading>
                    <Flexer />
                    <ModalClose onClick={onDismiss} />
                </>
            }>
            {/*      <LoadingComponent loading={loading} /> */}
            <View column></View>
        </Drawer>
    )
}
